import type { RefObject } from 'react';

import { useEffect } from 'react';

interface Params {
  galleryRef?: RefObject<HTMLUListElement | null> | null;
  progressBarRef?: RefObject<HTMLDivElement | null> | null;
}

export const useCarouselProgressBar = ({ galleryRef, progressBarRef }: Params) => {
  useEffect(() => {
    const gallery = galleryRef?.current;
    const scrollLine = progressBarRef?.current;

    const updateProgressBar = () => {
      if (!scrollLine) {
        return;
      }

      const viewWidth = gallery?.clientWidth || 0;
      const scrollLeft = (gallery?.scrollLeft || 0) + viewWidth;
      const scrollWidth = gallery?.scrollWidth || 0;

      const progressPercentage = (scrollLeft / scrollWidth) * 100;

      scrollLine.style.width = `${progressPercentage}%`;
    };

    gallery?.addEventListener('scroll', updateProgressBar);

    return () => {
      gallery?.removeEventListener('scroll', updateProgressBar);
    };
  }, [galleryRef, progressBarRef]);
};
